export function DisplayLarge({children, color, fontWeight = 900, textAlign='justify'}) {
    return (
        <span style={{
            textAlign,
            lineHeight: '1.1em',
            fontFamily: 'Open Sans',
            fontSize: '3.0625em',
            color,
            fontWeight,
        }}>{children}</span>
    );
}
